import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';
import { routeLocale } from '@/shared/lib/routeLocale';

export const productDetailQuery = (slug: string) =>
  defineQuery({
    queryKey: [...queryKeys.product.detail(slug), routeLocale()],
    queryFn: ({ signal }) => api.products.getBySlug(slug, signal),
    staleTime: 60_000,
    enabled: slug.length > 0,
  });
